import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiClientService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  apiCall<T>(
    endpoint: string,
    payload: Record<string, any> = {},
    headers: Record<string, string> = {},
    method: 'get' | 'post' | 'put' | 'delete' = 'post',
  ): Observable<T> {
    const url = `${this.baseUrl}/${endpoint}`;
    const httpHeaders = new HttpHeaders(headers);

    switch (method.toLowerCase()) {
      case 'get':
        return this.http
          .get<T>(url, {
            headers: httpHeaders,
            params: this.toHttpParams(payload),
            withCredentials: true,
          })
          .pipe(catchError(this.handleError));

      case 'post':
        return this.http
          .post<T>(url, payload, {
            headers: httpHeaders,
            withCredentials: true,
          })
          .pipe(catchError(this.handleError));

      case 'put':
        return this.http
          .put<T>(url, payload, { headers: httpHeaders, withCredentials: true })
          .pipe(catchError(this.handleError));

      case 'delete':
        return this.http
          .delete<T>(url, {
            headers: httpHeaders,
            body: payload,
            withCredentials: true,
          })
          .pipe(catchError(this.handleError));

      default:
        return throwError(() => new Error(`Unsupported method: ${method}`));
    }
  }

  private toHttpParams(params: Record<string, any>): HttpParams {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return httpParams;
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error.error || { error: error.message });
  }
}
